<script>

import TheScoresCompetitionCard from "./TheScoresCompetitionCard.vue";
import PrtfAchievementTypeApi from "../../Services/Api/PrtfAchievementTypeApi";
import TheInformationCompetitionDialog from "../../Dialogs/TheInformationCompetitionDialog.vue";
import ScholarshipCompetitionApi from "../../../scholarship/Services/Api/ScholarshipCompetitionApi";
import _ from "lodash";
export default {
  name: "TheHeaderScholarshipCard",

  props: {
    achievements: Array,
    selectedAchievements: Array,
    selectedAchievementType: Number,
    selectedDepartment: Number,
    payloadCompetition: Object,
  },

  data() {
    return {
      achievementTypes: [],
      check: false,
      achievementTypeRules: [
        v => !!v || 'Тип деятельности обязателен.',
      ],
      departmentRules: [
        v => !!v || 'Факультет обязателен.',
      ],
      validate: true,
      informationDialog: false,
      departments: [],
    }
  },

  mounted() {
    this.getAchievementTypes();
    this.getSetting();
  },

  components: {
    TheScoresCompetitionCard,
    TheInformationCompetitionDialog,
  },

  computed: {
    isStatementPresent() {
      return !_.isNil(this.payloadCompetition?.id);
    },

    dateOfStatement() {
      if(_.isNil(this.payloadCompetition?.updated_at)) {
        return "";
      }
      return this.payloadCompetition.updated_at
    },

    disabledButtonSend() {
      return !this.check;
    },

    isDepartmentManyOne() {
      return this.departments.length > 1;
    }
  },

  methods: {
    async getAchievementTypes() {
      const response = await PrtfAchievementTypeApi.index();
      if(_.isNil(response)) return;

      if (!response.data.hasOwnProperty("error")) {
        this.achievementTypes = response.data.achievement_types;
      }

    },

    saveStatement() {
      if (this.$refs.formScholarshipStatement.validate()) {
        this.check = false;
        this.$emit('save');
      }
    },

    async getSetting() {
      const response = await ScholarshipCompetitionApi.settingStatementStudent()
      if(_.isNil(response)) return;

      this.departments = response.data.setting.departments;
    },

  },
}
</script>

<template>
  <div>
    <v-card-title>
      Параметры заявления

      <v-spacer/>
      <v-btn
        x-small
        text
        class="rounded-xl"
        @click="informationDialog = true"
      >
        <v-icon small left>
          fa-question-circle
        </v-icon>
        Помощь
      </v-btn>

    </v-card-title>

    <v-form ref="formScholarshipStatement" lazy-validation v-model="validate">
      <v-card-text>
        <v-select
          label="Тип деятельности"
          outlined
          :items="achievementTypes"
          class="my-a rounded-xl"
          dense
          item-text="name"
          item-value="id"
          :value="selectedAchievementType"
          style="width: max(250px, 80%)"
          @change="$emit('selectType', $event)"
          color="teal darken-3"
          :rules="achievementTypeRules"
        />

        <v-select
          label="Факультет/Институт"
          v-if="isDepartmentManyOne"
          outlined
          :items="departments"
          class="my-a rounded-xl"
          dense
          item-text="name"
          item-value="id"
          :value="selectedDepartment"
          style="width: max(250px, 80%)"
          @change="$emit('selectDepartment', $event)"
          color="teal darken-3"
          :rules="departmentRules"
        />

        <the-scores-competition-card
          :achievements="selectedAchievements"
        />

        <div class="d-flex align-center">
          <v-checkbox
            v-model="check"
            color="teal darken-3"
            label="Я подверждаю, что ознакомлен с положением"
          >
          </v-checkbox>
          <v-btn
            icon
            href="https://cabinet.amursu.ru/uploads/sveden/Pol_st_Date/996/Pol_st_08.07.2021.pdf"
            target="_blank"
          >
            <v-icon>
              fa-file
            </v-icon>
          </v-btn>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn
          :disabled="disabledButtonSend"
          class="rounded-xl white--text transition-fast-out-slow-in"
          elevation="0"
          color="teal darken-3"
          @click="saveStatement"
        >
          Сохранить
        </v-btn>
        <v-btn
          v-if="isStatementPresent"
          class="rounded-xl white--text transition-fast-out-slow-in"
          elevation="0"
          color="teal darken-3"
          @click="$emit('delete')"
        >
          Удалить
        </v-btn>

        <v-spacer/>

        <v-chip small v-if="isStatementPresent" color="teal darken-3" class="white--text">
          Создано: {{dateOfStatement}}
        </v-chip>
      </v-card-actions>
    </v-form>

    <the-information-competition-dialog
      :visible="informationDialog"
      @close="informationDialog = false"
    />
  </div>
</template>

<style scoped>

</style>